import React from 'react'
import { inject } from 'mobx-react'
import PropTypes from 'prop-types'
import get from 'lodash/get'

function RenderField ({
  label,
  value,
  dataType,
  html,
  staticData,
  renderItems,
  className
}) {
  if (!value && !html) return null
  return (
    <div className='group'>
      {label ? (
        <span className='sidebar-wrapper__content__label--default'>
          {label}
        </span>
      ) : null}
      {html && (
        <p className={className} dangerouslySetInnerHTML={{ __html: html }} />
      )}
      <p className={className}>
        {dataType ? get(staticData.names, `${dataType}[${value}]`, '') : value}
      </p>
      {renderItems}
    </div>
  )
}

RenderField.propTypes = {
  staticData: PropTypes.object,
  label: PropTypes.string,
  html: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataType: PropTypes.string,
  renderItems: PropTypes.array,
  className: PropTypes.string
}

export default inject('staticData')(RenderField)
